import googlePlay from "/src/assets/google-play.svg";
import appStore from "/src/assets/app-store.svg";

export const descargaData = {
    title: "Descarga la aplicación",
    description: "<p>Abre la App Store en tu iPhone o Google Play en tu dispositivo Android. Busca toke y dale a “Instalar” u “Obtener” para descargar la aplicación.</p>",
    stores: [
        {
            type: "google-play",
            image: googlePlay,
            alt: "Disponible en Google Play",
            link: "https://play.google.com/store/apps/details?id=com.popular.app.android&pli=1"
        },
        {
            type: "app-store",
            image: appStore,
            alt: "Disponible en App Store",
            link: "https://apps.apple.com/us/app/banco-popular-dominicano/id583475424"
        }
    ]
}